import '../contexts/StreamCallContext.js';
import '../contexts/StreamI18nContext.js';
import { useStreamVideoClient } from '../contexts/StreamVideoContext.js';
import { useObservableValue } from './useObservableValue.js';

/**
 * Utility hook which provides access to client's state store.
 */
const useStore = () => {
    const client = useStreamVideoClient();
    if (!client) {
        throw new Error(`StreamVideoClient isn't initialized or this hook is called outside of <StreamVideo> context.`);
    }
    return client.state;
};
/**
 * Utility hook which provides a list of all notifications about created calls.
 * In the ring call settings, these calls can be outgoing (I have called somebody)
 * or incoming (somebody has called me).
 */
const useCalls = () => {
    const { calls$ } = useStore();
    return useObservableValue(calls$);
};
/**
 * Returns the current connected user.
 */
const useConnectedUser = () => {
    const { connectedUser$ } = useStore();
    return useObservableValue(connectedUser$);
};

export { useCalls, useConnectedUser, useStore };
//# sourceMappingURL=store.js.map
